module.exports = __webpack_public_path__ + "static/media/ic_camera.f9be872f.svg";